import { useState, useEffect } from 'react';
import { configureBoneyard } from 'boneyard-js/react';
import AppRoutes from './routes/AppRoutes';
import GlobalLoader from './components/GlobalLoader';
import "./app.css";
// Uncomment after running: npx boneyard-js build http://localhost:3000
//import './bones/registry';

configureBoneyard({ animate: 'shimmer', shimmerColor: '#e8e8e8', color: '#f0f0f0', darkColor: '#2a2a2a', darkShimmerColor: '#333333', speed: '1.6s', shimmerAngle: 110, stagger: 60, transition: 250 });

function App() {
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <GlobalLoader loading={initialLoading} />
      <div style={{ opacity: initialLoading ? 0 : 1, transition: 'opacity 0.3s ease-in-out' }}>
        <AppRoutes />
      </div>
    </>
  );
}

export default App;
